import { CUSTOM_ELEMENTS_SCHEMA, Injectable, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MyMaterialModule } from './material-modules';
import { environment } from 'src/environments/environment';

import { AngularFireModule } from "@angular/fire/compat";
import { AngularFirestoreModule } from "@angular/fire/compat/firestore";

import { HomeComponent } from './comps/home/home.component';
import { ContactUsComponent } from './comps/home/contactus/contact-us.component';
import { PrivacyComponent } from './comps/privacy/privacy.component';
import { TermComponent } from './comps/term/term.component';
import { MsaComponent } from './comps/msa/msa.component';
import { PartnerAgreementComponent } from './comps/partner-agreement/partner-agreement.component';
import { CookieConsentComponent } from './comps/cookie-consent/cookie-consent.component';
import { PageNotFoundComponent } from './comps/page-not-found/page-not-found.component';
import { BecomePartnerComponent } from './comps/become-partner/become-partner.component';
import { CostCalculatorComponent } from './comps/cost-calculator/cost-calculator.component';

@Injectable()
class PageTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }
  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);
    if (title) {
      this.title.setTitle(title);
    }
  }
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ContactUsComponent,
    CostCalculatorComponent,
    PrivacyComponent,
    TermComponent,
    MsaComponent,
    PartnerAgreementComponent,
    CookieConsentComponent,
    BecomePartnerComponent
  ],
  imports: [
    PageNotFoundComponent,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MyMaterialModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    FormsModule,
    CommonModule,
  ],
  providers: [
    { provide: TitleStrategy, useClass: PageTitleStrategy }
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { 
}
